import React from 'react';

import '../scss/Elements/_tables.scss';
import { Helmet } from 'react-helmet';
import { useTranslationHook } from '../hooks/UseTranslationHook';
import { UserTableAxios } from '../components/Tables/UserTable';

function ListUser() {
  const { titleUsersString } = useTranslationHook();

  return (
    <div className='table-module-container'>
      <Helmet>
        <title>{titleUsersString}</title>
      </Helmet>
      <div className='datatable'>
        <UserTableAxios />
      </div>
    </div>
  );
}

export default ListUser;
